module.exports = "@import \"gltf-varying\"\n@import \"gltf-vertex\""


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/Shaders/gltf-varying-vertex.glsl
// module id = 43
// module chunks = 0